import { TableCell, TableRow } from "@/ds/shadcn/components/ui/table";
import { DataView } from "@/features/common/components/dataview/DataView";
import { HeaderBar } from "@/features/common/components/HeaderBar";
import { useTitle } from "@/lib/common/useTitle";
import { type FC } from "react";
import csvIcon from "@/assets/csv.png";
import { Button } from "@/ds/shadcn/components/ui/button";
import { Link } from "react-router";

export const PageCsvTutorial: FC = () => {
	useTitle("CSV Import and Export");

	return (
		<>
			<HeaderBar title="CSV Import and Export" description="Using Fyendal's Collection CSV features" breadcrumb={[]} />

			<div className="type-description p-3 border-b">
				We recommend downloading this CSV to use as a reference.  It contains a few example transactions for some Welcome to Rathe Ninja cards.
			</div>

			<div className="flex justify-between border-b items-center gap-3 p-3">
				<div className="flex items-center gap-2">
					<img className="w-8" src={csvIcon} />

					<div>
						<div className="type-item">csv-example-1.csv</div>
						<div className="type-meta">644 B</div>
					</div>
				</div>

				<Link rel="noreferrer" target="_blank" to="https://fyendalscollection-static.s3.us-west-1.amazonaws.com/csv-example-1.csv">
					<Button variant="outline">
						Download
					</Button>
				</Link>
			</div>

			<div className="border-b">
				<DataView
					onlyUseGalleryForMobile
					items={csvFields}
					getKey={x => x.field}
					listViewHeaderLabels={["Field", "Required", "Default Value", "Notes"]}
					listViewHeaderClassNames={["w-32 @md:w-48", "w-32 @md:w-48", "w-32 @md:w-48", "w-132"]}
					listComponent={CsvInformationListView} />
			</div>
		</>
	);
};

const csvFields: CsvInformationProps[] = [
	{
		field: "Quantity",
		required: "Not Required",
		defaultValue: "1",
		notes: "The quantity of product that was purchased or sold."
	},
	{
		field: "Identifier",
		required: "Required",
		defaultValue: "",
		notes: "The identifier for the product that was purchased or sold e.g. WTR000-1ST-CF."
	},
	{
		field: "Description",
		required: "Not Required",
		defaultValue: "(Ignored)",
		notes: "This field can be uploaded, but will be ignored. Only the identifier is considered."
	},
	{
		field: "Action",
		required: "Not Required",
		defaultValue: "Purchase",
		notes: "Indicates if the transaction was a Purchase or a Sale."
	},
	{
		field: "Unit Amount",
		required: "Required",
		defaultValue: "",
		notes: "The price that each unit was purchased/sold for."
	},
	{
		field: "Currency",
		required: "Not Required",
		defaultValue: "USD",
		notes: "The currency that was used to complete the transaction."
	},
	{
		field: "Date",
		required: "Not Required",
		defaultValue: "Today's Date",
		notes: "Needs to be in dd MMM yyyy format e.g. 28 Jul 2023."
	}
];

interface CsvInformationProps {
	field: string;
	required: string;
	defaultValue: string;
	notes: string;
};

const CsvInformationListView: FC<CsvInformationProps> = (props: CsvInformationProps) => {
	const {
		field,
		required,
		defaultValue,
		notes
	} = props;

	return (
		<TableRow>
			<TableCell>{field}</TableCell>
			<TableCell>{required}</TableCell>
			<TableCell>{defaultValue}</TableCell>
			<TableCell>{notes}</TableCell>
		</TableRow>
	);
};
